// extracted by mini-css-extract-plugin
module.exports = {"body":"_6047f372","portfolioName":"_59a08b7f","designerConnectionWrapper":"_2220ffa2"};